//JavaScript Document
//organization/Organization.js
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { 
		//useHistory, 
		useNavigate,
		useParams 
} from 'react-router-dom';
import Edit from '@material-ui/icons/Edit';
import Swap from '@material-ui/icons/SwapHoriz';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import IconButton from '@material-ui/core/IconButton';
import PreviewIcon from '@material-ui/icons/Visibility';


const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow:1
	},
	org : {
		flexGrow:1,
		marginTop:30,
	},
	advancedCard : {
		margin: theme.spacing(1),
		display: "flex",
		flexDirection:"column",
		alignItems:"stretch",
		justifyContent:"center",
		flexWrap: "wrap"
	},
	advancedContent : {
		display: "flex",
		flexGrow: 1,
		alignItems: "center",
		justifyContent: "space-around",
		flexWrap: "wrap"
	},
	advancedContentVertical: {
		display: "flex",
		alignItems:"stretch",
		justifyContent:"space-around",
		flexGrow: 1,
		flexDirection: "column",
		flexWrap: "wrap"
	},
	timingInput : {
		margin: theme.spacing(1),
		width: 90
	},
  maxDisplayGrid: {
	  minHeight: 300
  }
}));

export default function Organization(props) {
	const classes = useStyles();
	const navigate = useNavigate();
	//params from props
  	const {handleSend, organization, onChange, user, setUser, altUser, setAltUser} = props;
  	const [loaded, setLoaded] = React.useState(false);
	//params from route URL
	const {id} = useParams();
	const [org, setOrg] = React.useState({
		name: "Loading",
		description: "Details",
		phone: '',
		email_suffix: '',
		members: []
	});
	const [orgs, setOrgs] = React.useState([]);
  	//const [signsList, setSignsList] = React.useState([]);
  	React.useEffect(() => {
		if(!loaded){
			getOrg();
			getOrgs();
		}
		console.log(org);
	});
  	const getOrg = (orgid) =>{
	  	setLoaded(true);
		var cid = orgid || id;
	  	handleSend({
		  	vso: 'organization',
			organization: cid
	  	}, (data) => {
			setOrg(data.organization);
			//console.log('data');
			//console.log(data);
			//console.log('organization');
			//console.log(data.organization);
	  	});
  	}
	const getOrgs = () => {
		handleSend({
			vso: 'orglist',
		}, (data) => {
			setOrgs(data.orgs);
			console.log(data.orgs);
		})
	}
	
	//handle user selecting an org from the dropdown
	const handleSelectOrg = (e, val, reason) => {
		console.log("org selected");
		if(val){
			if(val.id){
				navigate('/organization/'+val.id);
				getOrg(val.id);
			}
		}
		//console.log(e);
		//console.log(val);
		//console.log(reason);
	}
	
	//handle user click change organization
	const handleSwapOrg = (e) => {
		handleSend({
			vso: 'orguse',
			organization: id
		}, (data) => {
			if(data.organization){
				if(onChange){
					onChange(data.organization);
				}
			}
		});
	}
	
	
	const renderActions = () => {
		if(parseInt(id) === organization.id){
			return (<Button startIcon={<Edit />}>Edit</Button>);
		}
		console.log(id+' != '+organization.id);
		return (<Button onClick={handleSwapOrg} startIcon={<Swap />}>Change Organization</Button>)
	}

	const handleSwapUser = (member) => {
		if(!altUser.id){
			setAltUser(user);
		}
		if(member.organization !== organization.id){
			handleSwapOrg();
		}
		setUser(member);
		handleSend({
			vso: 'user',
			user : member,
			subaction : 'preview'
		});
	}

	const renderMember = (member, n) => {
		let action = '';
		if(user.usergroup === 1){
			action = (<IconButton name="preview as user" onClick={(e)=>{handleSwapUser(member)}}><PreviewIcon /></IconButton>);
		}
		return (
			<Card key={n} className={classes.advancedCard}>
				<CardHeader title={member.name} action={action}/>
				<CardContent className={classes.advancedContent}>
					<Typography>{member.email}</Typography>
				</CardContent>
			</Card>
		);
	}

	return (
		<div className={classes.root}>
			<Autocomplete
				id="search-org"
				options={orgs}
				style={{marginTop:75}}
				onChange={handleSelectOrg}
				getOptionLabel={(option) => option.name}
				renderInput={(params) => <TextField {...params} label="Organizations" variant="outlined" />}
			/>
			<Card>
				<CardHeader 
					title={org.name} 
					action={renderActions()}
				/>
				<CardContent>
					<div dangerouslySetInnerHTML={{__html:org.description}}></div>
					<Typography>{org.phone}</Typography>
					<Typography>{org.address}</Typography>
					<Typography>{org.email_suffix}</Typography>
				</CardContent>
	  		</Card>
			<Grid container justifyContent="space-around">
				{org.members ? org.members.map(renderMember) : (<Typography>No members</Typography>)}
			</Grid>
		</div>
	
	);
}
